// components/CartMapView.tsx
import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import icon from "../../../assets/icons/cart.PNG";
import { RESTAURANT_ID } from "../../../constants/constans";
import { useGetCartListByRestaurantIdQuery } from "../../../redux/services/cartServise";

export interface Locations {
  id: string;
  name: string;
  lat: number;
  lng: number;
  imageUrl: string;
  isFixedLocation: boolean;
}

const containerStyle = {
  width: "100%",
  height: "70vh",
};

const defaultCenter = {
  lat: 6.9270786,
  lng: 79.861243,
};

const libraries: ("places" | "geometry" | "marker")[] = [
  "places",
  "geometry",
  "marker",
];

const CartMapView: React.FC = () => {
  const restaurantId = RESTAURANT_ID;
  const iconURL =
    "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Icons/cart-icon.png";

  const [cartList, setCartList] = useState<any[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentLocation, setCurrentLocation] =
    useState<google.maps.LatLngLiteral | null>(null);
  const { data } = useGetCartListByRestaurantIdQuery(restaurantId);
  const [locationList, setLocationList] = useState<Locations[]>([]);
  const [selectedCart, setSelectedCart] = useState<Locations | null>(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_MAPS_API_KEY! ||
      "AIzaSyD_zEfLidcypXTaAVeiQVX5PHlrcj6xEpM",
    libraries,
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setCurrentLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    }
  }, []);

  useEffect(() => {
    if (data?.carts) {
      setCartList(data.carts);
    }
  }, [data]);

  useEffect(() => {
    const filteredCartList = cartList.filter(
      (cart) => cart.cartState === "Online" && cart.status === "Approved"
    );
    const mappedLocations: Locations[] = filteredCartList.map((cart: any) => ({
      id: cart.id,
      name: cart.displayName,
      lat: cart.location._latitude,
      lng: cart.location._longitude,
      imageUrl: cart.imageUrl,
      isFixedLocation: cart.isFixedLocation,
    }));
    setLocationList(mappedLocations);
  }, [cartList]);

  if (!isLoaded) return <div>Loading map...</div>;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      // center={currentLocation || defaultCenter}

      center={defaultCenter}
      zoom={14}
      options={{
        disableDefaultUI: false,
        clickableIcons: false,
        styles: []
      }}
    >
      {locationList.map((cart) => (
        <Marker
          key={cart.id}
          position={{ lat: cart.lat, lng: cart.lng }}
          icon={{
            url: cart.isFixedLocation ? iconURL : icon,
            scaledSize: new window.google.maps.Size(40, 40),
          }}
          onMouseOver={() => setSelectedCart(cart)}
        />
      ))}

      {selectedCart && (
        <InfoWindow
          position={{ lat: selectedCart.lat, lng: selectedCart.lng }}
          options={{ pixelOffset: new window.google.maps.Size(0, -40) }}
        >
          <div style={{ padding: "10px", maxWidth: "250px" }}>
            <h5>{selectedCart.name}</h5>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default CartMapView;
